import { PaperTreeProcessPreview } from "@/components/marketing/PaperTreeProcessPreview";
import { Heading } from "@/components/typography/Heading";
import { Text } from "@/components/typography/Text";
import { Button } from "@/components/ui/button";
import { ArrowLeft02Icon, WhatsappIcon } from "@hugeicons-pro/core-stroke-standard";
import { HugeiconsIcon } from "@hugeicons/react";
import { trackPaperTreeWhatsAppClick } from "@/lib/marketing-analytics";
import type { ReactElement } from "react";

const whatsappMessage =
  "السلام عليكم، أرغب في طلب تصميم شجرة ورقية لعائلتي. أود معرفة التفاصيل والسعر. عدد الأفراد التقريبي: ___.";
const whatsappUrl = `https://wa.me/966550438831?text=${encodeURIComponent(whatsappMessage)}`;

export default function PaperTreeLandingSection(): ReactElement {
  const trackWhatsAppClick = () => {
    trackPaperTreeWhatsAppClick({
      source: "website_landing_section",
      ctaLocation: "paper_tree_landing_section",
    });
  };

  return (
    <section id="paper-tree" className="py-10 md:py-12" dir="rtl">
      <div className="container mx-auto px-4">
        <article className="mx-auto flex max-w-3xl flex-col items-center px-5 py-4 text-center">
          <PaperTreeProcessPreview className="mx-auto" />

          <div className="mt-8">
            <Heading level={2} size="subsection">
              صمّم شجرتك الورقية
            </Heading>
            <Text size="small" className="mx-auto mt-2 max-w-2xl">
              تصميم مخصص وجاهز للطباعة أو المشاركة.
            </Text>
            <div className="mt-5">
              <Button
                asChild
                size="lg"
                className="h-11 w-full max-w-md gap-2 bg-green-600 px-5 text-sm font-semibold text-white hover:bg-green-700 sm:text-base"
              >
                <a href={whatsappUrl} target="_blank" rel="noreferrer" onClick={trackWhatsAppClick}>
                  <HugeiconsIcon icon={WhatsappIcon} size={18} />
                  طلب الشجرة الورقية عبر واتساب
                  <HugeiconsIcon icon={ArrowLeft02Icon} size={14} />
                </a>
              </Button>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
